<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from './form';
import {
  clickVisible,
  operateRiskRule,
} from './actions';

export default {
  name: 'RiskRuleList',
  extends: TablePage,
  components: { Form },
  data() {
    return {
      requestUrl: '/tax/v1/risk/rule/findConditions',
    };
  },
  mounted() {
    // The menu can override the list configuration through its functionCode query.
    this.getConfigList(this.$route.query.functionCode || 'risk_rule_list');
  },
  methods: {
    isExtendsFn(item) {
      if (item && (item.code === 'add' || item.buttonCode === 'add')) {
        return false;
      }
      return TablePage.methods.isExtendsFn.call(this, item);
    },

    modalClick({ val, row = {} }) {
      if (val.code === 'add') {
        this.formConfig = {
          ...this.formConfig,
          code: 'add',
          row,
          formFunctionCode: val.doCode || val.formFunctionCode || 'risk_rule_form',
        };
        this.modalConfig.title = val.name || '新增风控规则';
        this.formName = 'Form';
        this.openFull();
        return;
      }

      if (val.code === 'enable' || val.code === 'disable') {
        this.operationClick(val.code, row);
      }
    },

    operationClick(code, row) {
      return operateRiskRule({
        code,
        row,
        selection: this.selection,
        request,
        onEmpty: () => this.$message({ type: 'error', message: '请选择数据' }),
        onSuccess: () => {
          this.$message({ type: 'success', message: `${code === 'enable' ? '启用' : '禁用'}成功` });
          this.selection = [];
          this.getList();
        },
      });
    },

    clickVisible,
  },
};
</script>
